import { AbstractControl } from "@angular/forms";
import { markAbstractControlTouched } from "./controlsConfig.function";

export function whastAppFormate(length: number | undefined, control: AbstractControl<any, any> | null) {
    markAbstractControlTouched(control);

    if (control?.value.length >= 11 && control?.value != '') {
        zeros(length, control, 4);
    }
}

export function codeFormate(length: number | undefined, control: AbstractControl<any, any> | null) {
    markAbstractControlTouched(control);

    if (control?.value != '') {
        zeros(length, control, 1);
    }
}

function zeros(length: number | undefined, control: AbstractControl<any, any> | null, max: number): any {
    const value = cleanValue(!!control?.value ? control?.value.toString(): '')
    let digit: number = length == 0 ? 0 : (((length || 0) - max) - value.length);
    let zeros: string = '';

    // Verificar cuántos ceros ya hay al inicio
    const existingZeros = value.match(/^0+/)?.[0].length || 0;

    // Limitar la cantidad de ceros a agregar
    if (existingZeros < 2) {
        for (let i = 0; i < (digit); i++) {
            zeros += '0';
        }

        // Concatenar ceros al inicio del valor existente
        control?.setValue(zeros + value);
    }

    
    function cleanValue(value: string): string {
        return value.replace(/[^0-9]/g, ''); // Eliminar caracteres no numéricos
    }
}

  // Método para obtener los códigos concatenados en string
export function getConcatenatedCodes(prefix: string, control:AbstractControl<any, any>[]): string[] {
    return control.map((control: any) => {
        const value = control.value;
        // Verificar si el valor ya contiene el prefijo
        if (!value.includes(prefix)) {
            return `${prefix}${Number(value)}`;
        }
        // Si ya lo contiene, devolver el valor sin cambios
        return value;
    });
}